import { MagicTheGatheringApi } from "@/api/magic-the-gathering";
import { ILottoTicket, IMTGSet } from "@/interface";
import { MTGSetType } from "@/enum";

export const FILTED_SET_THRESHOLD = 50;
export const LARGE_SET_THRESHOLD = 200;
export const TINY_SET_THRESHOLD = 100;
const FILTER_SET_TYPE: {[type: string]: boolean} = {
    [MTGSetType.Expansion]: true,
    [MTGSetType.Core]: true,
    [MTGSetType.Masters]: true,
    [MTGSetType.Commander]: true,
    [MTGSetType.Funny]: true,
    [MTGSetType.DraftInnovation]: true,

    [MTGSetType.Box]: false,
    [MTGSetType.FromTheVault]: false,
    [MTGSetType.PremiumDeck]: false,
    [MTGSetType.DuelDeck]: false,
    [MTGSetType.Starter]: false,
    [MTGSetType.Planechase]: false,
    [MTGSetType.Archenemy]: false,
    [MTGSetType.Promo]: false,
    [MTGSetType.Vanguard]: false,
    [MTGSetType.Masterpiece]: false,
    [MTGSetType.Spellbook]: false,
};

const DISABLED_SET_TYPES = [
    MTGSetType.Masters,
    MTGSetType.Commander,
    MTGSetType.Funny,
];

const DISABLED_SET_CODES = [
    "lea",
    "leb",
    "2ed",
    "sum",
    "3ed",
    "fbb",
    "arn",
    "hml",
];

export class Lotto {
    public static async loadLotto(): Promise<Lotto> {
        const api = new MagicTheGatheringApi();
        const sets = await api.getSets();
        const filteredSets = sets.filter(
            (set) => FILTER_SET_TYPE[set.type] && FILTED_SET_THRESHOLD < set.totalSetSize,
        );

        filteredSets.sort((a, b) => {
            const aDate = new Date(a.releaseDate);
            const bDate = new Date(b.releaseDate);
            const dateDiff = aDate.valueOf() - bDate.valueOf();

            return dateDiff;
        });

        return new Lotto(filteredSets);
    }

    public sets: ILottoTicket[] = [];

    constructor(sets: IMTGSet[]) {
        this.sets = this.lottofy(sets);
    }

    public generateResult(setCount: number = 4): IMTGSet[] {
        const sets = this.sets
            .filter((ticket) => ticket.enabled)
            .map((ticket) => ticket.set);
        const shuffledSets = this.shuffle(sets);

        const result = shuffledSets.slice(0, setCount);

        this.logResult(result);

        return result;
    }

    public getSet(): IMTGSet {
        const sets = this.shuffle(
            this.sets
                .filter((ticket) => ticket.enabled)
                .map((ticket) => ticket.set),
            );
        return sets[0];
    }

    private lottofy(sets: IMTGSet[]): ILottoTicket[] {
        return sets.map((set) => ({
            enabled: this.setEnabledByDefault(set),
            set,
        }));
    }

    private setEnabledByDefault(set: IMTGSet): boolean {
        const possibleBanReasons = [
            set.totalSetSize > TINY_SET_THRESHOLD,
            !DISABLED_SET_CODES.includes(set.code),
            !DISABLED_SET_TYPES.includes(set.type),
        ];

        return possibleBanReasons.every((a) => a);
    }

    private logResult(result: IMTGSet[]): void {
        const log: string[] = JSON.parse(localStorage.getItem("log") || "[\"\",\"\",\"\",\"\",\"\"]");
        const names = result.map((set) => set.name);

        log.push(names.join("; "));
        log.shift();

        localStorage.setItem("log", JSON.stringify(log));
    }

    private shuffle<T>(target: T[]): T[] {
        for (let index = target.length - 1; index > 0; index--) {
            const swap = Math.floor(Math.random() * (index + 1));
            [target[index], target[swap]] = [target[swap], target[index]];
        }

        return target;
    }
}
